import JsonURL from '@jsonurl/jsonurl';

const JSON_URL_OPTIONS = {
  AQF: true,
  noEmptyComposite: true,
  ignoreNullObjectMembers: true,
  ignoreUndefinedObjectMembers: true,
};

export const parseJsonUrl = (json) => {
  return JsonURL.parse(json, JSON_URL_OPTIONS);
};

export const stringifyToJsonUrl = (data) => {
  return JsonURL.stringify(data, JSON_URL_OPTIONS);
};
